const TokenAuthenticationPage: React.FC = () => {
    return null;
};

export default TokenAuthenticationPage;
